var _path, _circle, _circle2, _circle3, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBuilderLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 133,
    height: 37,
    viewBox: "0 0 133 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4735 5.5359C17.286 3.89947 19.607 3.86254 20.4712 5.47228L23.0865 10.3441C24.1623 12.3481 25.8461 13.9593 27.8956 14.9458L31.3521 16.6095C32.9776 17.3919 33.0675 19.6732 31.5087 20.5811L27.1633 23.1123C25.5748 24.0375 24.2502 25.3547 23.3159 26.9378L20.4243 31.8377C19.5367 33.3419 17.3483 33.3052 16.5116 31.7721L14.0438 27.2507C13.0713 25.469 11.6142 23.9989 9.84109 23.0108L5.52376 20.6046C3.9157 19.7084 4.00577 17.3657 5.67789 16.5956L9.10982 15.015C11.3391 13.9883 13.15 12.2297 14.2415 10.0314L16.4735 5.5359Z",
    stroke: "#2B3330",
    strokeWidth: 1.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27.7659,
    cy: 9.74495,
    r: 1.1148,
    transform: "rotate(-44.2663 27.7659 9.74495)",
    stroke: "#2B3330",
    strokeWidth: 1.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 8.7581,
    cy: 27.3375,
    r: 1.1148,
    transform: "rotate(-44.2663 8.7581 27.3375)",
    stroke: "#2B3330",
    strokeWidth: 1.5
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 18.262,
    cy: 18.6256,
    r: 1.1148,
    transform: "rotate(-44.2663 18.262 18.6256)",
    stroke: "#2B3330",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.08 26C53.12 26 55.6 24.76 55.6 21.72C55.6 19.96 54.46 18.6 52.62 18.02V18C53.64 17.48 54.36 16.32 54.36 14.96C54.36 12.16 52.22 10.92 48.94 10.92H45.52V26H50.08ZM48.46 13.38H49.12C50.76 13.38 51.48 13.92 51.48 15.2C51.48 16.52 50.7 17.24 49.1 17.24H48.46V13.38ZM48.46 19.44H49.68C51.76 19.44 52.6 20.26 52.6 21.5C52.6 22.74 51.66 23.52 49.84 23.52H48.46V19.44ZM64.9805 26.28C68.2805 26.28 70.8805 24.26 70.8805 20.44V10.92H67.8605V20.06C67.8605 22.54 66.7005 23.52 64.9805 23.52C63.2605 23.52 62.1005 22.54 62.1005 20.12V10.92H59.0605V20.44C59.0605 24.26 61.6605 26.28 64.9805 26.28ZM77.9708 26V10.92H74.9708V26H77.9708ZM89.6859 26V23.22H85.2059V10.92H82.2059V26H89.6859ZM96.7819 26C101.782 26 105.082 23.28 105.082 18.52C105.082 13.64 101.662 10.92 96.5019 10.92H92.7419V26H96.7819ZM95.7419 13.68H96.6419C100.282 13.68 102.042 15.5 102.042 18.5C102.042 21.62 99.9419 23.3 96.6419 23.3H95.7419V13.68ZM117.586 26V23.4H111.786V19.18H117.326V16.62H111.786V13.52H117.546V10.92H108.786V26H117.586ZM128.006 19.82C130.106 18.94 131.146 17.46 131.146 15.54C131.146 12.28 128.686 10.92 125.246 10.92H121.626V26H124.626V20.14H125.066L128.846 26H132.446L128.006 19.82ZM125.366 13.52C127.206 13.52 128.186 14.16 128.186 15.6C128.186 17.1 127.106 17.78 125.286 17.78H124.626V13.52H125.366Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuilderLogo);
export default __webpack_public_path__ + "static/media/builder-logo.9a0527dc98f77fa83103b9838c12c495.svg";
export { ForwardRef as ReactComponent };